import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaPhoneAlt, FaArrowRight } from "react-icons/fa";
import { IoLocationSharp } from "react-icons/io5";
import SetTitle from "../../components/SetTitle";
import styles from "./Partner.module.scss";
import kidsIslandImg from "./assets/kids_island.jpg";
import littleRockstarImg from "./assets/little_rockstar.jpg";

const centers = [
	{
		cardTitle: "Kids Island International Pre School",
		image: kidsIslandImg,
		location: "Patia, Bhubaneswar",
		schoolTitle: "Kids Island International School",
		badge: "Pre School and Creche",
		desc: "A nurturing and vibrant space where children learn, play and grow with happiness. Discover a child-friendly environment designed to encourage curiosity, creativity and confident learning.",
		phones: ["+91 8917 327 419", "+91 9348 142 936"],
		reverse: false,
		link: "/Partner/KidsIsland",
	},
	{
		cardTitle: "Little Rockstar",
		image: littleRockstarImg,
		location: "Ranasinghpur, Bhubaneswar",
		schoolTitle: "Little Rockstar Pre School",
		badge: "Pre School and Creche",
		desc: "Where every child shines, learns and becomes a little rock star ! A joyful, nurturing environment designed to encourage curiosity, musical rhythm, and confident learning.",
		phones: ["+91 7848 933 200", "+91 8013 040 248"],
		reverse: true,
		link: "/Partner/LittleRockstar",
	},
];

const Partner = () => {
	SetTitle("Partner with MINE kids");
	const navigate = useNavigate();

	return (
		<div className={styles.Partner}>
			<div className={styles.Container}>
				{/* Top Hero */}
				<div className={styles.HeaderSection}>
					<h1>Partner with MINE kids</h1>
					<p className={styles.SubHeading}>
						Bring the joy of learning to more children by partnering with Mine Kids. Explore our franchise
						centers and discover learning spaces where little minds can learn, play and grow.
					</p>
				</div>

				{/* Partner Centers List */}
				<div className={styles.CentersWrapper}>
					{centers.map((c, i) => (
						<div key={i} className={`${styles.CenterRow} ${c.reverse ? styles.ReverseRow : ""}`}>
							{/* Card */}
							<div className={styles.CardWrapper}>
								<div
									className={`${styles.CenterCard} ${c.link ? styles.ClickableCard : ""}`}
									onClick={() => c.link && navigate(c.link)}
								>
									<h3 className={styles.CardTitle}>{c.cardTitle}</h3>
									<div className={styles.ImageContainer}>
										<img src={c.image} alt={c.schoolTitle} loading="eager" />
										<div className={styles.ImageOverlay}>
											<button
												type="button"
												className={styles.ViewDetailsBtn}
												onClick={(e) => {
													e.stopPropagation();
													if (c.link) navigate(c.link);
												}}
											>
												<span>View Details</span>
												<div className={styles.BtnArrowCircle}>
													<FaArrowRight className={styles.BtnArrowIcon} />
												</div>
											</button>
										</div>
									</div>
									<div className={styles.Location}>
										<IoLocationSharp className={styles.PinIcon} />
										<span>{c.location}</span>
									</div>
								</div>
							</div>

							{/* Info Section */}
							<div className={styles.InfoSection}>
								<h2 className={styles.SchoolTitle}>{c.schoolTitle}</h2>
								<span className={styles.Badge}>{c.badge}</span>
								<p className={styles.Description}>{c.desc}</p>

								<div className={styles.ContactBox}>
									<div className={styles.PhoneSection}>
										<div className={styles.PhoneIconCircle}>
											<FaPhoneAlt />
										</div>
										<div className={styles.PhoneNumbers}>
											{c.phones.map((p, idx) => (
												<a key={idx} href={`tel:${p.replace(/\s+/g, "")}`}>{p}</a>
											))}
										</div>
									</div>
									<a href={`tel:${c.phones[0].replace(/\s+/g, "")}`} className={styles.ContactNowBtn}>
										<span>Contact now</span>
										<div className={styles.ArrowCircle}>
											<FaArrowRight className={styles.ArrowIcon} />
										</div>
									</a>
								</div>
							</div>
						</div>
					))}
				</div>

				{/* Bottom CTA Banner */}
				<div className={styles.CtaBanner}>
					<div className={styles.CtaLeft}>
						<div className={styles.HandshakeIconWrapper}>
							<svg width="76" height="76" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg">
								<rect x="0.5" y="0.5" width="75" height="75" rx="37.5" fill="white" stroke="#E08C3E"/>
								<path d="M36.3218 49.1541L40.6646 53.4969C41.0923 53.9246 41.6001 54.2639 42.159 54.4954C42.7178 54.7269 43.3168 54.8461 43.9217 54.8461C44.5266 54.8461 45.1256 54.7269 45.6845 54.4954C46.2433 54.2639 46.7511 53.9246 47.1788 53.4969C47.6066 53.0692 47.9459 52.5614 48.1774 52.0025C48.4088 51.4437 48.528 50.8447 48.528 50.2398C48.528 49.6349 48.4088 49.0359 48.1774 48.477C47.9459 47.9182 47.6066 47.4104 47.1788 46.9827" stroke="#E08C3E" strokeLinecap="round" strokeLinejoin="round"/>
								<path d="M42.8361 42.6399L48.2647 48.0684C49.1285 48.9323 50.3001 49.4176 51.5218 49.4176C52.7434 49.4176 53.9151 48.9323 54.7789 48.0684C55.6428 47.2046 56.1281 46.0329 56.1281 44.8113C56.1281 43.5896 55.6428 42.418 54.7789 41.5542L46.3538 33.1291C45.1324 31.9092 43.4767 31.224 41.7504 31.224C40.0241 31.224 38.3685 31.9092 37.147 33.1291L35.2362 35.0399C34.3723 35.9038 33.2007 36.3891 31.9791 36.3891C30.7574 36.3891 29.5858 35.9038 28.7219 35.0399C27.8581 34.1761 27.3728 33.0045 27.3728 31.7828C27.3728 30.5612 27.8581 29.3895 28.7219 28.5257L34.8236 22.424C36.8045 20.4483 39.3877 19.1898 42.1644 18.8476C44.9411 18.5055 47.7526 19.0992 50.1538 20.5349L51.1744 21.1429C52.0989 21.7009 53.1982 21.8944 54.2578 21.6857L58.036 20.9257" stroke="#E08C3E" strokeLinecap="round" strokeLinejoin="round"/>
								<path d="M58.0364 18.7545L60.2078 42.64H55.865" stroke="#E08C3E" strokeLinecap="round" strokeLinejoin="round"/>
								<path d="M18.9506 18.7547L16.7792 42.6402L30.8934 56.7544C31.7572 57.6183 32.9288 58.1036 34.1505 58.1036C35.3721 58.1036 36.5438 57.6183 37.4076 56.7544C38.2714 55.8906 38.7568 54.719 38.7568 53.4973C38.7568 52.2757 38.2714 51.104 37.4076 50.2402" stroke="#E08C3E" strokeLinecap="round" strokeLinejoin="round"/>
								<path d="M18.9507 20.9256H36.322" stroke="#E08C3E" strokeLinecap="round" strokeLinejoin="round"/>
							</svg>
						</div>
						<h3 className={styles.CtaLeftTitle}>
							Interested in becoming a<br />MINE kids partner ?
						</h3>
					</div>

					<div className={styles.CtaDivider} />

					<div className={styles.CtaRight}>
						<p className={styles.CtaRightText}>
							Let’s build joyful learning spaces<br />together ?
						</p>
						<Link to="/ContactUs" className={styles.GetInTouchBtn}>
							<span>Get in touch</span>
							<div className={styles.CtaArrowCircle}>
								<FaArrowRight className={styles.CtaArrowIcon} />
							</div>
						</Link>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Partner;
